module.exports = __webpack_public_path__ + "img/brownWaterWard.f6cab58d.svg";